export default "__VITE_ASSET__Bww05VYJ__"